import { ReactNode } from 'react'
import cx from 'classnames'
import Styles from './Banner.module.scss'

interface Props {
  children?: ReactNode
  className?: string
  type?: 'info'
}

const Button = ({ children, className, type = 'info' }: Props) => {
  return <aside className={cx(Styles.banner, Styles[type], className)}>{children}</aside>
}
export default Button
